type DemoConfig = Record<string, unknown>;

const env = (import.meta as ImportMeta & { env?: Record<string, string> }).env ?? {};
const current = ((window as Window & { __MIXINIM_DEMO_CONFIG__?: DemoConfig }).__MIXINIM_DEMO_CONFIG__ ?? {});
const configured: DemoConfig = {};
const values: Array<[string, string]> = [
  ['businessApiUrl', 'VITE_MIXINIM_DEMO_API_URL'],
  ['imApiUrl', 'VITE_MIXINIM_API_URL'],
  ['websocketUrl', 'VITE_MIXINIM_WEBSOCKET_URL'],
  ['liveKitUrl', 'VITE_MIXINIM_LIVEKIT_URL'],
];
for (const [key, envKey] of values) {
  if (env[envKey]) configured[key] = env[envKey];
}
if (env.VITE_MIXINIM_USE_CONSUMER_SESSION === 'true') configured.useConsumerSession = true;
(window as Window & { __MIXINIM_DEMO_CONFIG__?: DemoConfig }).__MIXINIM_DEMO_CONFIG__ = { ...configured, ...current };

await import('../vue/call');
